import { ImgInfo } from "../api/app-user.class";
import { DraggableItemFactory } from "./draggable-item-factory.class";
import { itensComSuasImagens } from "./itens-da-pagina";
import { DraggableItem, DraggableItemObj } from "./draggable-item.class";

export type FirestoreLayerObj = {
  width: number;
  height: number;
  items: DraggableItemObj[];
};

export class Layer {
  width: number;
  height: number;
  items: DraggableItem[];

  /**
   * MONTAR UMA PAGINA A PARTIR DO QUE ESTA NO FIRESTORE.
   *
   * ── O QUE ESTAVA AQUI, E POR QUE ERA PERDA DE DADO ──────────────────────────────────────
   *
   * Esta funcao tinha uma linha a mais:
   *
   *     const filteredItems = obj.items.filter((item) => !item.imgId || item.imgId in imgs);
   *
   * Ou seja: **todo item cuja imagem ainda nao tinha chegado era DESCARTADO, em silencio.**
   *
   * E as imagens chegam DEPOIS. O `global-state-context` abre duas escutas independentes — uma
   * dos quadrinhos (linha 134) e uma das imagens (linha 157) — e a primeira resposta a chegar
   * pode ser qualquer uma das duas. Quando a dos quadrinhos chega antes, `imgs` esta vazio e o
   * quadrinho e montado SEM NENHUMA IMAGEM. Depois as imagens chegam, o efeito roda de novo, e o
   * quadrinho e remontado completo.
   *
   * ESSA E A CAUSA DO T2.47, e o ponto descreve exatamente a sequencia: *"eu abro a primeira, ele
   * aparece assim, ai eu clico em cima de novo"* ([A3-P33]) e *"nao tava aparecendo duas vezes
   * meu quadrinho e na segunda vez apareceu um erro absurdo"*. Primeira abertura: a pagina vem
   * sem os desenhos. Segunda: ja remontada, ou no meio da remontagem.
   *
   * E o T2.48 e a reacao dele a isso — *"isso aqui precisa ser alterado PRA ONTEM"*, o unico
   * ponto dos 109 em que ele marca urgencia.
   *
   * ── E O PIOR NAO ESTAVA NO PONTO ────────────────────────────────────────────────────────
   *
   * Descartar no CARREGAMENTO significa descartar na MEMORIA. E `Comic.save()` grava
   * `this.toObj()`, que percorre as paginas em memoria. Entao:
   *
   *     abrir o quadrinho antes das imagens chegarem  ->  os itens de imagem somem da memoria
   *     salvar                                        ->  somem do documento, PARA SEMPRE
   *
   * Nao e uma tela que pisca: e apagar o desenho da crianca. Ninguem relatou isso porque o
   * sintoma visivel e outro — a pagina "aparece assim" —, e a perda so se descobre depois.
   *
   * ── A CORRECAO, E O QUE ELA REVELA SOBRE O CODIGO ANTIGO ────────────────────────────────
   *
   * O item fica. Sem a imagem, ele nasce com URL vazia — e a linha de baixo JA TRATAVA ISSO:
   * `imgs[item.imgId]?.url || ""`. Aquele `|| ""` era codigo morto enquanto o filtro existia,
   * porque o filtro garantia que a chave estava presente.
   *
   * **Dois mecanismos para o mesmo caso, e eles discordavam.** Um dizia "descarte o que nao tem
   * imagem"; o outro, "aceite URL vazia". Sobrou o segundo, que e o que preserva o trabalho.
   */
  static fromFirestoreLayerObj(
    obj: FirestoreLayerObj,
    imgs: Record<string, ImgInfo>
  ) {
    // A DECISAO SOBRE A LISTA mora em `itens-da-pagina.ts`, e nao aqui, porque ela precisa de
    // TESTE — e este arquivo importa a cadeia do Konva, que nao carrega sob o jest sem o pacote
    // nativo `canvas`. Ver o cabecalho de la para o defeito que isso impede de voltar.
    return new Layer(
      obj.width,
      obj.height,
      itensComSuasImagens(obj.items, imgs).map(({ item, url }) =>
        DraggableItemFactory.fromObj(item, url)
      )
    );
  }

  constructor(width: number, height: number, items: DraggableItem[] = []) {
    this.width = width;
    this.height = height;
    this.items = items;
  }

  toObj() {
    return {
      width: this.width,
      height: this.height,
      items: this.items.map((item) => item.toObj()),
    };
  }

  copy(): Layer {
    return new Layer(
      this.width,
      this.height,
      this.items.map((item) => DraggableItemFactory.clone(item, true))
    );
  }
}
